// extracted by mini-css-extract-plugin
module.exports = {"desc":"_19928","content":"_3867"};